import { getSupabaseConfig } from "@/config/supabase";

function splitPathQueryHash(input: string): { path: string; suffix: string } {
  const hashIdx = input.indexOf("#");
  const queryIdx = input.indexOf("?");
  let cut = -1;
  if (hashIdx >= 0 && queryIdx >= 0) cut = Math.min(hashIdx, queryIdx);
  else cut = Math.max(hashIdx, queryIdx);
  if (cut === -1) return { path: input, suffix: "" };
  return { path: input.slice(0, cut), suffix: input.slice(cut) };
}

export function getBaseUrl(): string {
  const { url } = getSupabaseConfig();
  return url.replace(/\/$/, "");
}

export function storagePublicUrl(bucket: string, objectPath: string): string {
  const base = getBaseUrl();
  const { path, suffix } = splitPathQueryHash(objectPath || "");
  const cleanPath = path.replace(/^\/+/, "");
  const cleanBucket = bucket.replace(/^\/+|\/+$/g, "");
  const encoded = encodeURI(cleanPath);
  return `${base}/storage/v1/object/public/${cleanBucket}/${encoded}${suffix}`;
}

export function storagePublicUrlFromPath(fullPath: string): string {
  const { path, suffix } = splitPathQueryHash(fullPath || "");
  const clean = path.replace(/^\/+/, "");
  const [bucket, ...rest] = clean.split("/");
  const rel = rest.join("/");
  if (!bucket)
    throw new Error("storagePublicUrlFromPath: bucket missing in path");
  return storagePublicUrl(bucket, `${rel}${suffix}`);
}

export function functionUrl(name: string): string {
  const base = getBaseUrl();
  const clean = name.replace(/^\/+/, "");
  return `${base}/functions/v1/${clean}`;
}
